import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig, loginRequest, apiRequest } from "../authConfig";

export const msalInstance = new PublicClientApplication(msalConfig);
const msalReady = msalInstance.initialize();

class AuthService {
  isAuthenticated = false;
  user = null;
  permission = null;
  token = null;

  initialize = async () => {
    await msalReady;
    const accounts = msalInstance.getAllAccounts();
    if (accounts.length) {
      msalInstance.setActiveAccount(accounts[0]);
      this.user = accounts[0];
      this.isAuthenticated = true;
      const userGroups = this.user?.idTokenClaims?.groups || [];
      if (userGroups.includes(process.env.REACT_APP_FULL_ACCESS_USER)) {
        this.permission = "fullAccess";
      } else if (
        userGroups.includes(process.env.REACT_APP_RESTRICTED_ACCESS_USER)
      ) {
        this.permission = "restrictedAccess";
      } else {
        this.permission = "masterAccess";
      }
      return {
        isAuthenticated: true,
        user: this.user,
        permission: this.permission,
      };
    }
    return { isAuthenticated: false, user: null };
  };

  login = async () => {
    const res = await msalInstance.loginPopup(loginRequest);
    msalInstance.setActiveAccount(res.account);
    this.user = res.account;
    this.isAuthenticated = true;
    const userGroups = this.user?.idTokenClaims?.groups || [];
    if (userGroups.includes(process.env.REACT_APP_FULL_ACCESS_USER)) {
      this.permission = "fullAccess";
    } else if (
      userGroups.includes(process.env.REACT_APP_RESTRICTED_ACCESS_USER)
    ) {
      this.permission = "restrictedAccess";
    } else {
      this.permission = "masterAccess";
    }
    return {
      isAuthenticated: true,
      user: this.user,
      permission: this.permission,
    };
  };

  logout = async () => {
    await msalInstance.logoutPopup({
      postLogoutRedirectUri: "/",
      mainWindowRedirectUri: "/",
    });
    this.permission = null;
    this.user = null;
    this.token = null;
    this.isAuthenticated = false;
  };

  acquireToken = async (scopes = apiRequest.scopes) => {
    await msalReady;
    const account =
      msalInstance.getActiveAccount() || msalInstance.getAllAccounts()[0];
    if (!account) throw new Error("No active account");
    try {
      const res = await msalInstance.acquireTokenSilent({ account, scopes });
      this.token = res.accessToken;
      return res.accessToken;
    } catch {
      const res = await msalInstance.acquireTokenPopup({ account, scopes });
      this.token = res.accessToken;
      return res.accessToken;
    }
  };
}

export const authService = new AuthService();
